module.exports = __webpack_public_path__ + "static/img/service-1.a267f095.png";